import Flex from 'src/components/Layout/Flex/Flex'
import styled, { css } from 'styled-components'
import { MainPanelWrapperProps } from '../types'
import theme from 'src/components/Core/Styles/theme'
import { ButtonStyle } from 'src/components/Atoms/Button/Button.styles'
import { CircleButtonWrapperProps } from './types'

const BorderStyle = `2px solid ${theme.colors.shades.neutral[1]}`

export const ButtonsWrapper = styled(Flex)`
  position: fixed;
  bottom: 232px;
  right: 32px;
`

export const CircleButtonWrapper = styled(Flex)<CircleButtonWrapperProps>`
  min-width: 40px;
  width: 40px;
  max-width: 40px;
  min-height: 40px;
  height: 40px;
  max-height: 40px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.main[props.bgColor || 'dark']};
  z-index: 10;
  cursor: pointer;

  ${props => props.border && css`
    svg {
      border: 2px solid ${theme.colors.main.blank};
      border-radius: 50%;
    }
  `}

  ${props => props.disabledButton && css`
    background-color: ${props => props.theme.colors.shades.neutral[2]};
    cursor: not-allowed;
  `}
`

export const MainPanelWrapper = styled(Flex)<MainPanelWrapperProps>`
  position: absolute;
  z-index: 0;
  width: 312px;
  height: 100%;
  top: 0px;
  right: ${props => props.isOpen ? '0': '-312'}px;
  background-color: ${props => props.theme.colors.main.background};
  border-left: 3px solid ${props => props.theme.colors.shades.neutral[2]};
  overflow-y: auto;
  transition: all 0.1s ease-in-out;
  box-sizing: border-box;
`

export const Title = styled(Flex)`
  padding: 16px 8px 10px 10px;
  border-bottom: ${BorderStyle};
  box-sizing: border-box;
`

const replyPadding: Record<string, string> = {
  firstReply: '16px 8px 20px 0px',
  nextReply: '0 16px 0 16px'
}

export const NewThreadBox = styled(Flex)<{isReply?: string}>`
  padding: ${props => props.isReply ? replyPadding[`${props.isReply}`] : '16px 8px 20px 10px'};
  border-bottom: ${props => props.isReply ? 'none' : BorderStyle};
  box-sizing: border-box;
`

export const NewThreadButtons = styled(Flex)`
  ${ButtonStyle} {
    width: 80px;
    height: 36px;
  }
`

export const Threads = styled(Flex)`
  margin: 0;
  padding: 0;
`

export const ThreadBox = styled(Flex)<{isReply?: boolean, chevronUp?: boolean;}>`
  padding: ${props => props.isReply ? '20px 16px 0 16px' : '20px 16px 20px 32px'};
  border-bottom: ${props => props.isReply ? 'none' : BorderStyle};
  box-sizing: border-box;

  & > div {
    cursor: pointer;
    
    p { 
    cursor: pointer;
    }
  }

  path {
    transform: rotate(${props => props.chevronUp ? '180deg' : '0'});
    transform-origin: center;
    transition: all 0.1s ease-in-out;
  }

`
export const Replies = styled(Flex)<{zeroReply?: boolean}>`
  padding: 0;
  ${props => props.zeroReply && css`
    width: 100%;
  `}
`
